// extracted by mini-css-extract-plugin
export default {"login_bg_img_container":"LoginBg_login_bg_img_container__uMrfN","tagline":"LoginBg_tagline__Yho46","loginPage_bg":"LoginBg_loginPage_bg__58GrK"};